// extracted by mini-css-extract-plugin
export default {"modalBody":"disable-tag-modal_modalBody__YIlIC","applyButton":"disable-tag-modal_applyButton__H4+Eq"};